import { Vue, Component, Prop, Mixins, Watch } from "vue-property-decorator";
import Cleave from 'vue-cleave-component';
import RightsAware from '@/lib/mixins/rights-aware';
import moment from "moment";

@Component
export default class DateInput extends Mixins(RightsAware) {

  @Prop({default: () => null, required: false, type: Date}) readonly value!: Date;

  protected internalV_: string = "";

  @Watch("value", {immediate: true})
  onValueChange() {
    this.internalV_ = this.valueAsString;
  }

  get valueAsString() {
    return this.value && moment(this.value).format("DDMMYYYY");
  }

  get isValid() {
    return moment(this.internalV_, "DDMMYYYY", true).isValid();
  }

  onInput(e) {
    this.internalV_ = e;
    if (this.isValid) {
      this.$emit("input", moment(this.internalV_, "DDMMYYYY").toDate());
    }
  }

  render() {
    return (
      <Cleave value={this.internalV_} class={`input is-small ${this.isValid ? '' : 'has-text-danger'}`}
        placeholder="dd/mm/yyyy"
        options={{date: true, datePattern: ['d', 'm', 'Y'], delimiter: '/'}}
        onInput={this.onInput}
        readonly={this.isReadonly}/>
    )
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-0a5ebe0f/date-input.tsx" });